var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-nav bg-white border-top-radius elevation-1 d-flex justify-content-between"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }